import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addSplitReturnAmount from "./components/addSplitReturnAmount";
import { callbackAmountSplitManageData, callbackSwitchConfigManageData as _callbackSwitchConfigManageData, callbackAmountSplitManageDel } from "@/api/financial/backhaul";
import backhaul from "./mixins/backhaul";
import { serchSelect } from "@/mixins/index";
import parameterPopupAmount from "./components/parameterPopupAmount";
export default {
  name: "splitReturnedAmount",
  mixins: [backhaul, serchSelect],
  components: {
    addSplitReturnAmount: addSplitReturnAmount,
    parameterPopupAmount: parameterPopupAmount
  },
  data: function data() {
    return {
      tableData: [],
      reqLoading: false,
      total: 0,
      searchData: {}
    };
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.callbackSwitchConfigManageData();

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    searchClick: function searchClick(e) {
      var _this2 = this;

      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.reqLoading = true;
      callbackAmountSplitManageData().then(function (res) {
        if (res.status == 200) {
          _this2.tableData = res.data;
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    callbackSwitchConfigManageData: function callbackSwitchConfigManageData() {
      var _this3 = this;

      if (!this.searchData.special_product_id || !this.searchData.special_product_id.toString()) {
        this.searchData.special_product_id_all = this.productsList.map(function (i) {
          return i.id;
        });
      } else {
        this.searchData.special_product_id_all = this.searchData.special_product_id;
      }

      _callbackSwitchConfigManageData(_objectSpread(_objectSpread({}, this.searchData), {}, {
        product_id: this.searchData.special_product_id_all
      })).then(function (res) {
        if (res.status == 200) {
          _this3.callbackSwitchConfigData = res.data;
          console.log("this.callbackSwitchConfigData", _this3.callbackSwitchConfigData); // this.total = res.data.total
        }
      }).finally(function () {});
    },
    handleDelete: function handleDelete(row) {
      var _this4 = this;

      this.$confirm("此操作将删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                callbackAmountSplitManageDel({
                  id: row.id,
                  switch_id: row.switch_id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this4.searchClick();

                    _this4.$message({
                      type: "success",
                      message: "删除成功!"
                    });
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    }
  }
};